<script setup lang="ts">
  defineOptions({ name: 'EventsPageHeader' })

  import { computed, type PropType } from 'vue'
  import { useI18n } from 'vue-i18n'

  import { createElementId } from '@common/core-layer/utils'

  import CPText from '@ui/components/CPText.vue'

  import type { EventsPageHeaderHeading } from '../../types/events-hub'

  const props = defineProps({
    heading: {
      type: String as PropType<EventsPageHeaderHeading>,
      default: 'events',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    idPrefix: {
      type: String,
      default: 'events',
    },
  })

  const { t } = useI18n()

  const resolvedTitle = computed(() => {
    const override = props.title.trim()
    return override || t(`clientportal.events.pageHeader.${props.heading}.title`)
  })

  const resolvedDescription = computed(() => {
    const override = props.description.trim()
    return override || t(`clientportal.events.pageHeader.${props.heading}.description`)
  })
</script>

<template>
  <header :id="createElementId(idPrefix, 'header', 'root')" class="flex flex-col">
    <CPText
      :id="createElementId(idPrefix, 'header', 'title')"
      html-tag="h1"
      type="display"
      size="xs"
      weight="semibold"
      class="tracking-tight text-900"
    >
      {{ resolvedTitle }}
    </CPText>
    <CPText :id="createElementId(idPrefix, 'header', 'description')" html-tag="p" size="lg" weight="regular" class="mt-1 text-500">
      {{ resolvedDescription }}
    </CPText>
  </header>
</template>
